module.exports = __webpack_public_path__ + "img/check-mark.8f875e21.svg";